var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28718_21338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.5625H0.96875C0.84443 14.5625 0.725201 14.5131 0.637294 14.4252C0.549386 14.3373 0.5 14.2181 0.5 14.0938V1.4375H1.4375V13.625H15.5V14.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.6875H2.375V11.75C6.0575 11.75 7.13516 9.37859 8.27656 6.86844C9.43344 4.32266 10.745 1.4375 15.0312 1.4375H15.5V12.6875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28718_21338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.8598cbfdc03984d9d67b76e7f38a296d.svg";
export { ForwardRef as ReactComponent };